export default "__VITE_PUBLIC_ASSET__d694594b__"